import React from "react";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";


import "./VoteWithoutAuth.scss";

export const COOKIE_KEY = "1DE3kWS7AO5G6WlByQaH";

export const userIsLogin = () => useSelector(state => state.user.token) !== "";

export function hasPhotoVoted(photo, userIsLogin) {
  if (userIsLogin) {
    return photo.voted;
  }

  const votedPhotosAsGuest = Cookies.get(COOKIE_KEY)
    ? JSON.parse(Cookies.get(COOKIE_KEY))
    : [];

  return votedPhotosAsGuest.indexOf(photo.id) !== -1;
}

function VoteWithoutAuth({ onVoteCallback, onVote, photo }) {
  const { t } = useTranslation(["widgets"]);
  const votedObjects = Cookies.get(COOKIE_KEY)
    ? JSON.parse(Cookies.get(COOKIE_KEY))
    : [];

  const submitVote = e => {
    e.preventDefault();
    votedObjects.push(photo.id);
    Cookies.set(COOKIE_KEY, JSON.stringify(votedObjects), { secure: true });
    onVote();
    onVoteCallback();
  };

  return (
    <div className="vote-without-auth">
      <p>{t("widgets:gallery.or")}</p>
      <h5>{t("widgets:gallery.voteTitle")}</h5>
      {votedObjects.indexOf(photo.id) === -1 ? (
        <form onSubmit={submitVote}>
          <button type="submit" className="bttn bttn--yellow">
            {t("widgets:gallery.vote")}
          </button>
        </form>
      ) : (
        <button type="button" className="bttn bttn--yellow bttn-disable">
          {t("widgets:gallery.alreadyVote")}
        </button>
      )}
    </div>
  );
}

export default VoteWithoutAuth;
